import LogoPayto from '~/react/components/Logo/LogoPayto'
import LogoBecs from '~/react/components/Logo/LogoBecs'

const getPaymentMethodLogo = (paymentMethod, logoProps = {}) => {
  if (paymentMethod?.paymentNetwork === 'becs') {
    return <LogoBecs {...logoProps} />
  }

  // Default to PayTo logo for 'payto' or any other network
  return <LogoPayto {...logoProps} />
}

export default getPaymentMethodLogo
